import { Container, Row, Col } from "react-bootstrap";

function Projects() {
  const projects = [
    {
      title: "API-Fest-22",
      img: "https://camo.githubusercontent.com/de81597fc3c30e74a11f0c334ea99ef6ccba479003f6eddb7906167ef5b1dba3/68747470733a2f2f7062732e7477696d672e636f6d2f6d656469612f464a416548493658774141705377452e6a7067",
      github: "https://github.com/Vazgen47/API-Fest-25",
    },
    {
      title: "HacktoberFestswag",
      img: "https://raw.githubusercontent.com/swapnilsparsh/hacktoberfest-swag/master/public/image/Banner.png",
      github: "https://github.com/Vazgen47/hacktoberfestswag",
    },
    {
      title: "MysuruTourism",
      img: "https://github.com/swapnilsparsh/MysuruTourism/raw/master/img/Readme%20Image.png",
      github: "https://github.com/Vazgen47/MysuruTourism",
    },
    {
      title: "CodingDaubts",
      img: "https://github.com/swapnilsparsh/CodingDoubts/raw/master/static/Meta.jpeg",
      github: "https://github.com/Vazgen47/CodingDaubts",
    },
    {
      title: "ChatSociety",
      img: "https://github.com/swapnilsparsh/ChatSociety/raw/master/public/ScreenShot.png",
      github: "https://github.com/Vazgen47/ChatSociety",
    },
  ];

  return (
    <Container
      fluid
      className="project-section"
      id="projects"
      style={{
        position: "relative",
        paddingTop: "100px",
        paddingBottom: "100px",
        background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
        color: "#fff",
      }}
    >
      <Container>
       
        <h1 className="project-heading mb-5">
          My <strong className="purple">Projects</strong> 
        </h1>

        
        <Row className="justify-content-center g-4">
          {projects.map((project, index) => (
            <Col md={4} sm={6} xs={12} key={index}>
              <div className="project-card rounded-4 shadow-lg p-3 text-center">
                <img
                  src={project.img}
                  alt={project.title}
                  className="w-100 rounded-3 mb-3"
                  style={{
                    objectFit: "cover",
                    height: "220px",
                    border: "1px solid rgba(255,255,255,0.1)",
                    transition: "transform 0.4s ease",
                  }}
                />
                <h4 className="fw-bold text-light">{project.title}</h4>
                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-light btn-sm mt-2"
                  style={{
                    borderRadius: "50px",
                    padding: "0.5rem 1.5rem",
                    transition: "all 0.3s ease",
                  }}
                >
                  View on GitHub
                </a>
              </div>
              
            </Col>
            
          ))}
           <h1 className="project-heading mb-5">
          More to my <strong className="purple">GitHub</strong> 
        </h1>
        
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
